function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { sizes_default } from "./chunk-NJCYBKFH.mjs";
import { runIfFn } from "./chunk-UV3F75RF.mjs";

// src/components/avatar.ts
import { avatarAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
import { isDark, randomColor } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  definePartsStyle = _createMultiStyleConf.definePartsStyle,
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig;
var $border = cssVar("avatar-border-color");
var $bg = cssVar("avatar-bg");
var $fs = cssVar("avatar-font-size");
var $size = cssVar("avatar-size");
var baseStyleBadge = defineStyle(_defineProperty(_defineProperty({
  borderRadius: "full",
  border: "0.2em solid",
  borderColor: $border.reference
}, $border.variable, "white"), "_dark", _defineProperty({}, $border.variable, "colors.gray.800")));
var baseStyleExcessLabel = defineStyle(_defineProperty(_defineProperty({
  bg: $bg.reference,
  fontSize: $fs.reference,
  width: $size.reference,
  height: $size.reference,
  lineHeight: "1"
}, $bg.variable, "colors.gray.200"), "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.400")));
var baseStyleContainer = defineStyle(function (props) {
  var name = props.name,
    theme = props.theme;
  var bg = name ? randomColor({
    string: name
  }) : "colors.gray.400";
  var isBgDark = isDark(bg)(theme);
  var color = "white";
  if (!isBgDark) color = "gray.800";
  return _defineProperty(_defineProperty({
    bg: $bg.reference,
    fontSize: $fs.reference,
    color: color,
    borderColor: $border.reference,
    verticalAlign: "top",
    width: $size.reference,
    height: $size.reference,
    "&:not([data-loaded])": _defineProperty({}, $bg.variable, bg)
  }, $border.variable, "colors.white"), "_dark", _defineProperty({}, $border.variable, "colors.gray.800"));
});
var baseStyleLabel = defineStyle({
  fontSize: $fs.reference,
  lineHeight: "1"
});
var baseStyle = definePartsStyle(function (props) {
  return {
    badge: runIfFn(baseStyleBadge, props),
    excessLabel: runIfFn(baseStyleExcessLabel, props),
    container: runIfFn(baseStyleContainer, props),
    label: baseStyleLabel
  };
});
function getSize(size) {
  var themeSize = size !== "100%" ? sizes_default[size] : void 0;
  return definePartsStyle({
    container: _defineProperty(_defineProperty({}, $size.variable, themeSize != null ? themeSize : size), $fs.variable, "calc(".concat(themeSize != null ? themeSize : size, " / 2.5)")),
    excessLabel: _defineProperty(_defineProperty({}, $size.variable, themeSize != null ? themeSize : size), $fs.variable, "calc(".concat(themeSize != null ? themeSize : size, " / 2.5)"))
  });
}
var sizes = {
  "2xs": getSize(4),
  xs: getSize(6),
  sm: getSize(8),
  md: getSize(12),
  lg: getSize(16),
  xl: getSize(24),
  "2xl": getSize(32),
  full: getSize("100%")
};
var avatarTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md"
  }
});
export { avatarTheme };